export function later(ms: number, {signal}: { signal?: AbortSignal } | undefined = {}): Promise<void> {
    if (signal) {
        return new Promise<void>((resolve, reject) => {
            if (signal.aborted) {
                reject(signal.reason);
                return;
            }
            const timeout = setTimeout(() => resolve(), ms);
            signal.addEventListener('abort', () => {
                clearTimeout(timeout);
                reject(signal.reason);
            })
        })
    }
    return new Promise<void>((resolve) => {
        setTimeout(() => resolve(), ms);
    });
}

export function neverResolve(): Promise<never> {
    return new Promise<never>(() => {
        // This promise will never resolve
    });
}

export const e = (function () {
    if (typeof document === 'object') {
        const div = document.createElement('div')
        return (text: string) => {
            div.innerText = text;
            return div.innerHTML;
        }
    } else {
        // If the document is not available (WebWorkers), only do a basic HTML escape
        return (text: string) => text.replace(/[&<>"']/g, (match) => {
            switch (match) {
                case '&':
                    return '&amp;';
                case '<':
                    return '&lt;';
                case '>':
                    return '&gt;';
                case '"':
                    return '&quot;';
                case "'":
                    return '&#39;';
                default:
                    return match; // Should not happen
            }
        });
    }
})()
